var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.57219C0 0.90945 0.537258 0.372192 1.2 0.372192H22.8C23.4627 0.372192 24 0.90945 24 1.57219C24 2.23493 23.4627 2.77219 22.8 2.77219H1.2C0.537258 2.77219 0 2.23493 0 1.57219ZM0 9.97212C0 9.30937 0.537259 8.77212 1.2 8.77212H16.8C17.4627 8.77212 18 9.30937 18 9.97212C18 10.6349 17.4627 11.1721 16.8 11.1721H1.2C0.537259 11.1721 0 10.6349 0 9.97212ZM1.2 17.1722C0.537258 17.1722 0 17.7095 0 18.3722C0 19.035 0.537258 19.5722 1.2 19.5722H22.8C23.4627 19.5722 24 19.035 24 18.3722C24 17.7095 23.4627 17.1722 22.8 17.1722H1.2Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.09f0f79a66223df6d3cebed3d6d4fe26.svg";
export { ForwardRef as ReactComponent };